module.exports = __webpack_public_path__ + "static/item--chloe--f4@3x.eb08b092.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/item--chloe--f4@3x.png
// module id = 638
// module chunks = 126511778744290